import axiosInstance from '../config/axios.config';
import ENDPOINTS from '../config/endpoints';

class ContactService {
  // Create a contact/support message.
  // Pass { skipAuth: true } for guest submissions so no auth token is attached.
  async create(payload, options = {}) {
    const res = await axiosInstance.post(ENDPOINTS.CONTACT.CREATE, payload, options);
    return res.data;
  }

  // Admin: list all contact/support messages.
  async list({ page = 0, limit = 10, search = '' } = {}) {
    const res = await axiosInstance.get(ENDPOINTS.CONTACT.LIST, {
      params: { page, limit, search },
    });
    return res.data;
  }
}

const contactService = new ContactService();
export default contactService;
